import { useQuery } from '@tanstack/react-query';
import { GetMandateParams, getMandate } from '@/ar/network/AccountsReceivable.network';

export const FETCH_MANDATE_QUERY_KEY = 'FETCH_MANDATE_QUERY_KEY';

export const useGetMandate = (params: GetMandateParams) => useQuery([FETCH_MANDATE_QUERY_KEY, params], async () => getMandate(params), { enabled: !!params.mandateID });
